module.exports = __webpack_public_path__ + "static/img/eye-black.6d4f311c.svg";